import { TSeoFaqItem } from '@/entities/catalog-brands/types/type'

import { TSeoResponse } from '@/shared/types/deprecated-types'

export enum FilterDisplayType {
	RangeWithSlider = `A`,
	Range = `B`,
	CheckBox = `F`,
	CheckBoxWithPicture = `G`,
	CheckBoxWithLabelAndPicture = `H`,
	Radio = `K`,
	Select = `P`,
	SelectWithLabelAndPicture = `R`
}

export enum FilterPropertyType {
	Number = `N`,
	List = `L`
}

export enum FilterJsonType {
	Price = `><`,
	Default = `=`
}

export enum SortType {
	PopularityToLow = `popular`,
	PriceLowToHigh = `price|asc`,
	PriceHighToLow = `price|desc`,
	NewFirst = `date|asc`
}

export type FilterValue = {
	CHECKED?: boolean
	FILTERED_VALUE: number
	ELEMENT_COUNT: number
	SORT: number
	VALUE: string | number
	ID: string
	NAME?: string
}

export type FilterProperties = {
	CODE: string
	DISPLAY_EXPANDED: boolean
	DISPLAY_TYPE: `${FilterDisplayType}`
	FILTER_HINT: string
	ID: string
	NAME: string
	DISABLED?: boolean
	PROPERTY_TYPE: `${FilterPropertyType}`
	VALUES: FilterValue[]
}

export type FilterData = {
	FILTER_URL_SEF?: string
	PROPERTIES: FilterProperties[]
	SEO: TSeoResponse
	FAQ: TSeoFaqItem[]
}

export type FilterJsonProperties = {
	[key: string]: {
		type: FilterJsonType
		value: (string | number)[]
	}
}
